export default function TaskList() {
  const tasks = [
    { id: 1, name: 'Finding String Manager', status: 'Active', version: 'v0.0.1' },
    { id: 2, name: 'FortnitePro X', status: 'Active', version: 'v0.0.1' },
    { id: 3, name: 'GetResult Auto Protection', status: 'Active', version: 'v0.0.1' },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-white">Active Tasks</h2>
        <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700">
          + Add Task
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="text-gray-400 text-left">
              <th className="pb-4">Name</th>
              <th className="pb-4">Version</th>
              <th className="pb-4">Status</th>
              <th className="pb-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => (
              <tr key={task.id} className="border-t border-gray-700">
                <td className="py-4 text-white">{task.name}</td>
                <td className="py-4 text-white">{task.version}</td>
                <td className="py-4">
                  <span className="bg-green-500/20 text-green-500 px-3 py-1 rounded-full">
                    {task.status}
                  </span>
                </td>
                <td className="py-4">
                  <button className="text-blue-500 hover:text-blue-400 mr-3">Edit</button>
                  <button className="text-red-500 hover:text-red-400">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
} 